<template>
    <div :class="{'enlarge-menu': !hasChildren||(hasChildren&&enlargeMenu), 'enlarge-menu-all': isScreenWidthMd}"
         class="mm-active active mm-show">
        <LeftBar :confirmView="false" @enlargeMenu="isHasChildren"/>
        <AppHeader :confirmView="false" @enlargeMenu="changeEnlargeMenu"/>
        <b-button class="pairing-btn text-left" v-if="$store.getters.role != 'ROLE_ADMIN'" variant="danger">
            <i class="fas fa-user mr-3"></i>
            <span class="btn-label"></span>
        </b-button>
        <RightBar/>
        <div class="page-wrapper">
            <div class="page-content-tab">
                <div class="container-fluid">
                    <router-view/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AppHeader from './navbar/AppHeader';
    import LeftBar from './leftbar/LeftBar';
    import RightBar from './rightbar/RightBar';

    export default {
        name: 'AppLayout',
        components: {RightBar, LeftBar, AppHeader},
        data() {
            return {
                enlargeMenu: false,
                isScreenWidthMd: screen.width < 1025,
                actualMenu: null,
                hasChildren: Boolean
            };
        },
        methods: {
            changeEnlargeMenu() {
                if (this.hasChildren) {
                    this.enlargeMenu = !this.enlargeMenu;
                }
            },
            isHasChildren(e) {
                this.hasChildren = e;
            }
        }
    };
</script>

<style scoped>
    .pairing-btn {
        position: fixed;
        display: none;
        top: 50vh;
        right: 0;
        z-index: 99999;
        width: 2.5rem;
        transition: width 0.3s;
        transition-timing-function: ease-in-out;
    }

    .pairing-btn:hover {
        width: 12rem;
    }

    .btn-label {
        position: fixed;
    }

    .pairing-btn:hover .btn-label:after {
        content: "Parrainer un filleul";
    }
</style>
